<template>
  <Doughnut
    id="donut-id"
    :options="mergedChartOptions"
    :data="chartData"
  />
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Colors } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { getChartLabelPlugin } from 'chart.js-plugin-labels-dv'

const centerTotalPlugin = {
  id: 'centerTotalPlugin',
  afterDraw(chart) {
    if (chart.config.type !== 'doughnut') return

    const config = chart?.options?.plugins?.centerTotal
    if (!config || config.display === false) return

    const { ctx, chartArea, data } = chart
    if (!ctx || !chartArea || !data?.datasets?.length) return

    const datasetIndex = config.datasetIndex ?? 0
    const dataset = data.datasets[datasetIndex]

    if (!dataset || !Array.isArray(dataset.data)) return

    const total = dataset.data.reduce((acc, value) => acc + (Number(value) || 0), 0)

    const text =
      typeof config.valueFormatter === 'function'
        ? config.valueFormatter(total)
        : total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })

    const subtext = config.subtext || ''

    const centerX = (chartArea.left + chartArea.right) / 2
    const centerY = (chartArea.top + chartArea.bottom) / 2

    const mainColor = config.color || '#344767'
    const subColor = config.subColor || '#6b7280'

    const mainFontSize = config.fontSize || 22
    const subFontSize = config.subFontSize || 12

    const mainFontFamily = config.fontFamily || 'Arial'
    const subFontFamily = config.subFontFamily || 'Arial'

    const mainFontWeight = config.fontStyle || '700'
    const subFontWeight = config.subFontStyle || '400'

    const lineGap = config.lineGap || 18
    const offsetY = config.offsetY || 0

    ctx.save()
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    if (subtext) {
      ctx.fillStyle = mainColor
      ctx.font = `${mainFontWeight} ${mainFontSize}px ${mainFontFamily}`
      ctx.fillText(text, centerX, centerY - lineGap / 2 + offsetY)

      ctx.fillStyle = subColor
      ctx.font = `${subFontWeight} ${subFontSize}px ${subFontFamily}`
      ctx.fillText(subtext, centerX, centerY + lineGap / 2 + offsetY)
    } else {
      ctx.fillStyle = mainColor
      ctx.font = `${mainFontWeight} ${mainFontSize}px ${mainFontFamily}`
      ctx.fillText(text, centerX, centerY + offsetY)
    }

    ctx.restore()
  }
}

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Colors,
  ChartDataLabels,
  getChartLabelPlugin(),
  centerTotalPlugin
)

export default {
  name: 'DonutChart',
  components: { Doughnut },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    mergedChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        ...this.chartOptions
      }
    }
  }
}
</script>